import axios from 'axios';

export function sendForm(formId, sessionToken, payload) {
	return axios.post(`/apps/formpost/${formId}/sessions/${sessionToken}/complete`, payload);
}

export function sendTemporaryForm(formId, sessionToken, pageId, payload) {
	return axios.post(`/apps/formpost/${formId}/sessions/${sessionToken}/temporary/pages/${pageId}`, payload);
}

export function getTemporaryForm(formId, sessionToken) {
	return axios.get(`/apps/formpost/${formId}/sessions/${sessionToken}/temporary`);
}

export function validateTemporaryForm(formId, sessionToken, pageId, payload) {
	return axios.post(`/apps/formpost/${formId}/sessions/${sessionToken}/temporary/pages/${pageId}/validate`, payload);
}

export function uploadFiles(formId, sessionToken, pageNumber, fileInputId, files, onUploadProgress) {
	return axios.post(`/apps/formpost/${formId}/sessions/${sessionToken}/pages/${pageNumber}/files/${fileInputId}`, files, {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		onUploadProgress: onUploadProgress(fileInputId)
	});
}

export function getUploadedFiles(formId, sessionToken, fileInputId) {
	return axios.get(`/apps/formpost/${formId}/sessions/${sessionToken}/files/${fileInputId}`);
}

export function deleteFile(formId, sessionToken, fileInputId, filename) {
	return axios.delete(`/apps/formpost/${formId}/sessions/${sessionToken}/files/${fileInputId}`, {
		params: {
			filename
		}
	});
}



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-utils/DNFORM-api.js